export default "__VITE_ASSET__CqVqtCHG__"